import React, { useEffect, useRef, useState } from 'react';
import styles from './navbar.module.css';
import { IoIosArrowDown } from "react-icons/io";
import { Cart, Close, Contact, CrossIcon, Like, Search, StarIcon } from '../../../../Svg';
import HamburgerMenu from '../HamburgerMenu/HamburgerMenu';
import Goldrate from '../../Goldrate/Goldrate';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAppearances, getGoldRate } from '../../../../redux/homeSlice';
import { setVisible } from '../../../../redux/authModelSlice';
import { getPopularProduct, getProductsBySearch, getSubCategoryNames, setFilterValues, setRecentSearches } from '../../../../redux/productsSlice';
import { Box, CircularProgress, Dialog, Paper } from '@mui/material';
import LogoutConfirmation from '../../../../Dashboard/components/logout/logout';
import { setLoggedin } from "../../../../redux/userSlice";
import { useCurrency } from '../../../context/CurrencyContext';

const Navbar = ({ message, onClose }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const { goldRateData, appearanceData } = useSelector((state) => state.appearances);
  const { productsBySearchData, isLoading, filterOptions, popularProductsData, recentSearchesData, } = useSelector((state) => state.products);
  // console.log('subcategoriesByCategoryId', subcategoriesByCategoryId);

  const [recentSearches, setRecentSearchesData] = useState([]);
  // console.log('recentSearches', recentSearchesData);
  const { isLoggedIn, user } = useSelector((state) => state.user)
  const [isSubCategoryOpen, setIsSubCategoryOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [isPopupVisible, setIsPopupVisible] = useState(false); // Popup hidden initially
  const [sidebar, setSidebar] = useState(false);
  const [showRecent, setShowRecent] = useState(false);
  const location = useLocation();
  const toggleSidebar = () => setSidebar(!sidebar);
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [isLogoutDialogOpen, setIsLogoutDialogOpen] = useState(false);
  const handleLogoutClick = () => setIsLogoutDialogOpen(true);
  const [showCurrencyDropdown, setShowCurrencyDropdown] = useState(false);
  const { selectedCountry, setSelectedCountry } = useCurrency();

  const countries = [
    { name: 'India', currency: 'INR', code: 'in' },
    { name: 'USA', currency: 'USD', code: 'us' },
    { name: 'Australia', currency: 'AUD', code: 'au' },
    { name: 'Bahrain', currency: 'BHD', code: 'bh' },
    { name: 'Belgium', currency: 'EUR', code: 'be' },
    { name: 'Canada', currency: 'CAD', code: 'ca' },
    { name: 'China', currency: 'CNY', code: 'cn' },
    { name: 'Denmark', currency: 'DKK', code: 'dk' },
    { name: 'Finland', currency: 'EUR', code: 'fi' },
    { name: 'France', currency: 'EUR', code: 'fr' },
    { name: 'Germany', currency: 'EUR', code: 'de' },
    { name: 'Hong Kong', currency: 'HKD', code: 'hk' },
    { name: 'Italy', currency: 'EUR', code: 'it' },
    { name: 'Japan', currency: 'JPY', code: 'jp' },
    { name: 'Korea', currency: 'KRW', code: 'kr' },
    { name: 'Kuwait', currency: 'KWD', code: 'kw' },
    { name: 'Liechtenstein', currency: 'CHF', code: 'li' },
    { name: 'Macau', currency: 'MOP', code: 'mo' },
    { name: 'Malaysia', currency: 'MYR', code: 'my' },
    { name: 'Netherlands', currency: 'EUR', code: 'nl' },
    { name: 'Russia', currency: 'RUB', code: 'ru' },
    { name: 'Singapore', currency: 'SGD', code: 'sg' },
    { name: 'South Africa', currency: 'ZAR', code: 'za' },
    { name: 'Spain', currency: 'EUR', code: 'es' },
    { name: 'Switzerland', currency: 'CHF', code: 'ch' },
    { name: 'Taiwan', currency: 'TWD', code: 'tw' },
    { name: 'Thailand', currency: 'THB', code: 'th' },
    { name: 'UAE', currency: 'AED', code: 'ae' },
    { name: 'UK', currency: 'GBP', code: 'gb' },
  ];


  // const handleCountrySelect = (country) => {
  //   setSelectedCountry(country);
  //   setShowCurrencyDropdown(false);
  // };
  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    localStorage.setItem('selectedCountry', JSON.stringify(country));
    setShowCurrencyDropdown(false);
  };

  const menuRef = useRef(null);
  const searchInputRef = useRef(null);
  const currencyDropdownRef = useRef(null);

  //categories
  const categoriesData = appearanceData?.categories
  // console.log('categoriesData', categoriesData);


  // console.log(user);


  const handleClose = () => {
    setIsPopupVisible(false);
  };

  const handleGoldrateClick = () => {

    setIsPopupVisible(true);
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    dispatch(setFilterValues({ query: e.target.value }));
  };

  useEffect(() => {
    dispatch(getGoldRate())
  }, [dispatch])

  useEffect(() => {
    dispatch(getAppearances())
  }, [dispatch])

  useEffect(() => {
    const getAllProducts = async () => {
      try {
        await dispatch(getProductsBySearch(filterOptions));
      } catch (error) {
        console.log(error);
      }
    };
    getAllProducts();
  }, [dispatch, filterOptions]);

  useEffect(() => {
    const searches = JSON.parse(localStorage.getItem("recentSearches")) || [];
    setRecentSearchesData(searches);
  }, [recentSearchesData]);

  useEffect(() => {
    dispatch(getPopularProduct())
  }, [dispatch]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (currencyDropdownRef.current && !currencyDropdownRef.current.contains(event.target)) {
        setShowCurrencyDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);



  const handleSearchClick = (search) => {
    dispatch(getProductsBySearch({ query: search })).then(() => {
      setRecentSearchesData(JSON.parse(localStorage.getItem("recentSearches")) || []);
    });
  };


  const handleClick = () => {
    // console.log(isLoggedIn);

    if (!isLoggedIn) {
      return dispatch(setVisible('signin'))
    } else {
      navigate('/myprofile')
    }
  }
  const handleMobileViewClick = () => {
    // console.log(isLoggedIn);

    if (!isLoggedIn) {
      return dispatch(setVisible('signin'))
    } else {
      setSidebar('/myprofile')
    }
  }
  const handleWishlistClick = () => {
    if (!isLoggedIn) {
      return dispatch(setVisible('signin'))
    }
    navigate('/wishlist')
  }
  const handleCartClick = () => {
    if (!isLoggedIn) {
      return dispatch(setVisible('signin'))
    }
    navigate('/cart')
  }


  const handleCategoryHover = (categoryId) => {
    if (hoveredCategory !== categoryId) {
      setHoveredCategory(categoryId);
      // dispatch(getSubCategoryNames(`?categoryId=${categoryId}`));  // Fetch subcategories when hovering
    }
  };
  const handleDeleteSearch = () => {
    setSearch("");
  };

  const handleLogoutConfirm = () => {
    localStorage.clear();
    dispatch(setLoggedin(false));
    setIsLogoutDialogOpen(false);
    navigate("/");
  };

  const handleLogoutCancel = () => setIsLogoutDialogOpen(false)
  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setSidebar(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const defaultCountry = { name: 'India', currency: 'INR', code: 'in' };
    setSelectedCountry(defaultCountry);
    localStorage.setItem('selectedCountry', JSON.stringify(defaultCountry));
  }, [setSelectedCountry]);


  const menuItems = [
    { path: "/myprofile", label: "My Profile", icon: <MyProfileIcon /> },
    {
      path: "/orders",
      label: "Order History",
      icon: <OrderHistoryIcon />,
    },
    { path: "/shippingAddress", label: "Address", icon: <AddressIcon /> },
    { path: "/", label: "Log-out", icon: <LogoutIcon />, action: handleLogoutClick },

    // { path: "Log-out", label: "Log-in",  icon: < />, action: handleLogoutClick }, // Logout with action to open dialog
  ];

  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);

  const mobileSearchView = () => {
    setIsMobileSearchOpen(true);
  };

  const closeMobileSearch = () => {
    setIsMobileSearchOpen(false);
  };



  // Desktop search: button click
  const handleDesktopSearchClick = () => {
    if (searchInputRef.current) searchInputRef.current.blur();
    navigate(`/SearchedProduct?query=${search}`);
    setSearch("");
  };

  // Desktop search: Enter key
  const handleDesktopSearchKeyDown = (event) => {
    if (event.key === "Enter") {
      if (searchInputRef.current) searchInputRef.current.blur();
      setShowRecent(false);
      navigate(`/SearchedProduct?query=${search}`);
      setSearch("");
    }
  };

  // Mobile search: icon click
  const handleMobileSearchClick = () => {
    if (searchInputRef.current) searchInputRef.current.blur();
    navigate(`/SearchedProduct?query=${search}`);
    setSearch("");
    closeMobileSearch();
  };

  // Mobile search: Enter key
  const handleMobileSearchKeyDown = (event) => {
    if (event.key === "Enter") {
      if (searchInputRef.current) searchInputRef.current.blur();
      navigate(`/SearchedProduct?query=${search}`);
      setSearch("");
      closeMobileSearch();
    }
  };



  return (
    <>
      <div className={styles.navContainer}>
        <div className={styles.section}>
          <div className={styles.container}>
            <div className={styles.logo}>
              <div className={styles.menubar}>
                {/*  <Menubar /> */}
                <HamburgerMenu />
              </div>
              <img src="/pavithrajewelslogo.png" alt="Logo" onClick={() => navigate('/')} />
            </div>
            {/* search desktop view */}
            <div className={styles.searchcontant} >
              <div className={styles.search}>
                <button onClick={handleDesktopSearchClick}>
                  <span role="img" aria-label="search"><Search /></span>
                </button>
                <input
                  ref={searchInputRef}
                  type="text"
                  placeholder="Search here....."
                  enterKeyHint="go"
                  onClick={() => setShowRecent(true)}
                  value={search}
                  onKeyDown={handleDesktopSearchKeyDown}
                  onChange={handleSearch}
                />
                {search && <div onClick={handleDeleteSearch} style={{ cursor: 'pointer' }}><CrossIcon /></div>}
              </div>
              {search && showRecent ? (
                <div className={styles.recent} style={{ display: search && showRecent ? "block" : "none" }}>
                  <div className={styles.quicksearch}>
                    <span>Quick access</span>
                    {isLoading ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 20 }}>
                        <CircularProgress />
                      </Box>
                    ) : (
                      <>
                        {productsBySearchData?.length > 0 ? (
                          <div className={styles.recentlist}>
                            <div className={styles.searchProductLis}>
                              {productsBySearchData?.map((item) => (
                                <div onClick={() => {
                                  setShowRecent(false)
                                  navigate(`/prodDescription/${item?._id}`)
                                  // setSearch(false)
                                  window.scrollTo(0, 0);
                                }}
                                  className={styles.popularlist}
                                >
                                  <StarIcon />
                                  <p className={styles.productNametext}>{item?.productName}</p>
                                </div>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 20, textAlign: 'center' }}>
                            No data found
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  <div className={styles.popularsearch}>
                    <span>Trending Products</span>
                    {popularProductsData.length > 0 ? (
                      <div className={styles.quicklist}>
                        {popularProductsData?.map((search, index) => (
                          // <p key={index} onClick={() => handleSearchClick(search)} style={{ cursor: "pointer" }}>
                          //   {search?.productName && search?.productName?.length > 6 ? `${search?.productName?.substring(0, 6)}...` : search?.productName}
                          // </p>
                          <div className={styles.quicklistitems} onClick={() => handleSearchClick(search)} style={{ cursor: "pointer" }}>
                            <img src={search?.featurerdImage} alt='featurerdImage' style={{ width: 150, height: 150, objectFit: 'cover' }} />
                            <div className={styles.overlap}>
                              <h2>{search?.productName}</h2>
                              {/* <span>{item?.}</span> */}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p>No popular searches found</p>
                    )}
                  </div>
                </div>
              ) : null}
            </div>


            <div className={styles.icons}>
              {/* search Mobile view */}
              <div className={styles.icon1} onClick={mobileSearchView}>
                <Search />
              </div>
              {isMobileSearchOpen && (
                <div className={styles.mobileSearchOverlay}>
                  <div className={styles.mobileSearchPopup}>
                    <div className={styles.mobileSearchHeader}>
                      <div onClick={handleMobileSearchClick}>
                        <Search />
                      </div>
                      <input
                        ref={searchInputRef}
                        type="text"
                        placeholder="Search here....."
                        enterKeyHint="go"
                        value={search}
                        onKeyDown={handleMobileSearchKeyDown}
                        onChange={handleSearch}
                      />
                      <button onClick={() => {
                        closeMobileSearch()
                        handleDeleteSearch()
                      }} style={{ cursor: 'pointer' }}><CrossIcon /></button>
                    </div>

                    <div className={styles.mobileSearchBody}>
                      {isLoading ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 20 }}>
                          <CircularProgress />
                        </Box>
                      ) : (
                        <>
                          {productsBySearchData?.length > 0 ? (
                            <div className={styles.recentlist}>
                              {productsBySearchData?.map((item) => (
                                <div
                                  onClick={() => {
                                    navigate(`/prodDescription/${item?._id}`);
                                    closeMobileSearch();
                                  }}
                                  className={styles.popularlist}
                                >
                                  <StarIcon />
                                  <p className={styles.productNametext}>{item?.productName}</p>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div style={{ textAlign: 'center', padding: 20, height: "calc(100% - 40px)", display: "flex", justifyContent: "center", alignItems: "center" }}>
                              No data found
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )}


              <div
                ref={currencyDropdownRef}
                className={styles.currencyDropdown}
              >
                <div
                  className={styles.currencyButton}
                  onClick={() => setShowCurrencyDropdown(!showCurrencyDropdown)}
                >
                  <img
                    src={`https://flagicons.lipis.dev/flags/4x3/${selectedCountry.code}.svg`}
                    alt={selectedCountry.name}
                    className={styles.currencyFlag}
                  />
                  <span className={styles.currencyText}>
                    {selectedCountry.currency}
                  </span>
                  <IoIosArrowDown className={styles.currencyArrow} />
                </div>

                {showCurrencyDropdown && (
                  <div className={styles.currencyDropdownMenu}>
                    {countries.map((country) => (
                      <div
                        key={country.name}
                        onClick={() => handleCountrySelect(country)}
                        className={`${styles.currencyItem} ${selectedCountry.name === country.name ? styles.currencyItemActive : ''
                          }`}
                      >
                        <img
                          src={`https://flagicons.lipis.dev/flags/4x3/${country.code}.svg`}
                          alt={country.name}
                          className={styles.currencyFlag}
                        />
                        <div className={styles.currencyName}>
                          {country.currency}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>


              <div className={styles.icon2} onClick={handleWishlistClick}>
                <div style={{ position: 'relative' }}>
                  <Like />
                  {user?.unreadWishlistCount > 0 &&
                    <div style={{
                      position: 'absolute',
                      top: -7,
                      right: -5,
                      background: 'red',
                      color: 'white',
                      fontSize: 11,
                      borderRadius: '50%',
                      minWidth: 15,
                      minHeight: 15,
                      textAlign: 'center',
                      zIndex: 1,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                    >{user?.unreadWishlistCount}
                    </div>
                  }
                </div>
              </div>
              <div className={styles.icon3} onClick={handleCartClick}>
                <div style={{ position: 'relative' }}>
                  <Cart />
                  {user?.unreadCartCount > 0 &&
                    <div style={{
                      position: 'absolute',
                      top: -7,
                      right: -5,
                      background: 'red',
                      color: 'white',
                      fontSize: 11,
                      borderRadius: '50%',
                      minWidth: 15,
                      minHeight: 15,
                      textAlign: 'center',
                      zIndex: 1,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                    >{user?.unreadCartCount}
                    </div>
                  }
                </div>
              </div>
              <div className={styles.icon4} onClick={handleClick}>
                <Contact />
              </div>
              <div className={styles.mobileViewProfile} onClick={handleMobileViewClick}>
                <Contact />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.section2}>
          <div className={styles.container2}>
            <div className={styles.menu}>
              <div className={styles.dropdownTrigger} onClick={() => navigate('/')}>HOME</div>

              {categoriesData?.map((category) => {
                // const subcategories = subcategoriesByCategoryId[category._id] || [];
                return (
                  <div key={category._id}
                    className={styles.dropdownContainer}
                    onMouseEnter={() => handleCategoryHover(category._id)}
                    onMouseLeave={() => setHoveredCategory(null)}
                  >
                    <div
                      className={styles.dropdownTrigger}
                      onClick={() =>
                        navigate(`/product/${category?._id}`, { state: category?.name })
                      }
                    >
                      {category?.name} {category?.subcategories?.length > 0 && (<span><IoIosArrowDown className={styles.dropdownIcon} /></span>)}
                    </div>

                    {/* Only show subcategories if this category is selected */}
                    {hoveredCategory === category._id ? (

                      <>
                        {category?.subcategories?.length > 0 ? (
                          <div className={styles.dropdownMenu}>
                            {category?.subcategories?.map((subCategory) => (
                              <div
                                key={subCategory._id}
                                className={styles.dropdownItem}
                                onClick={() => {
                                  setHoveredCategory(null)
                                  navigate(`/productsWithSubCategory/${subCategory?._id}`, { state: category, })
                                  setIsSubCategoryOpen(!isSubCategoryOpen)
                                }}
                              >
                                {subCategory?.name}
                              </div>
                            ))}
                          </div>
                        ) : null}
                      </>
                    ) : null}
                  </div>
                )
              })}

              {/* <div className={styles.dropdownTrigger}>Offers</div> */}

              {/* <div className={styles.dropdownContainer}>
                <div
                  className={styles.dropdownTrigger}
                  onClick={() => setisMoreOpen(!isMoreOpen)}
                >
                  MORE <span><IoIosArrowDown className={styles.dropdownIcon} /></span>
                </div>

                {isMoreOpen && (
                  <div className={styles.dropdownMenu}>
                    <div className={styles.dropdownItem} onClick={() => navigate('/faq')}>Faq</div>
                  </div>
                )}
              </div> */}
            </div>

            <div className={styles.timer}>
              <button onClick={handleGoldrateClick}>Today’s Gold rate</button>
            </div>
          </div>
        </div>
        {/* Conditionally render the LoginPopup based on the state */}
        {isPopupVisible && (
          <Goldrate onClose={handleClose} goldRateData={goldRateData} />
        )}

        {/* Recent searches  */}
        <div ref={menuRef} className={sidebar ? `${styles.mobilenav} ${styles.open}` : styles.mobilenav} onClick={toggleSidebar}>
          {menuItems.map((item) =>
            item.action ? (
              <li
                key={item.label}
                className={styles.profilemenuItem}
                onClick={item.action}
              >
                <div className={styles.profileicon}>{item.icon}</div>
                <span>{item.label}</span>

              </li>
            ) : (
              <Link
                key={item.path}
                to={item.path}
                style={{ textDecoration: "none" }}
              >
                <li
                  className={`${styles.profilemenuItem} ${location.pathname === item.path
                    ? styles.profileactive
                    : ""
                    }`}
                >
                  <span className={styles.profileicon}>{item.icon}</span>
                  {item.label}
                </li>
              </Link>
            )
          )}
        </div>
        <Dialog open={isLogoutDialogOpen}>
          <LogoutConfirmation onClose={handleLogoutCancel} handleLogoutConfirm={handleLogoutConfirm} />
        </Dialog>
      </div>
    </>
  );
};

export default Navbar;

const MyProfileIcon = () => (
  <svg
    width="84"
    height="24"
    viewBox="0 0 94 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 21H13V15H21V21ZM11 21H3V11H11V21ZM21 13H13V3H21V13ZM11 9H3V3H11V9Z"
      fill="#FFFFFF"
    />
  </svg>
);

const OrderHistoryIcon = () => (

  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 20V13H11L7.783 16.22C8.33247 16.7819 8.98837 17.2287 9.71241 17.5343C10.4364 17.8399 11.2141 17.9983 12 18C13.2393 17.9982 14.4475 17.6127 15.4589 16.8965C16.4702 16.1802 17.2349 15.1684 17.648 14H17.666C17.78 13.675 17.867 13.34 17.925 13H19.937C19.6934 14.9333 18.7527 16.7111 17.2913 18C15.83 19.2888 13.9485 20 12 20H11.99C10.9398 20.0032 9.89944 19.798 8.9291 19.3963C7.95876 18.9946 7.07772 18.4045 6.337 17.66L4 20ZM6.074 11H4.062C4.30548 9.06751 5.24564 7.29019 6.70616 6.00145C8.16667 4.7127 10.0472 4.00108 11.995 4.00004H12C13.0504 3.99671 14.0909 4.20183 15.0615 4.6035C16.032 5.00517 16.9132 5.59541 17.654 6.34004L20 4.00004V11H13L16.222 7.78004C15.672 7.21752 15.0153 6.77035 14.2903 6.46471C13.5654 6.15907 12.7867 6.0011 12 6.00004C10.7607 6.00187 9.55246 6.38738 8.54114 7.10361C7.52982 7.81985 6.76508 8.83166 6.352 10H6.334C6.219 10.325 6.132 10.66 6.075 11H6.074Z" fill="white" />
  </svg>

);
const WishlistIcon = () => (
  <svg
    width="84"
    height="24"
    viewBox="0 0 94 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9997 19.0538C-7.99987 7.99967 6.00011 -4.00033 11.9997 3.58772C18.0001 -4.00034 32.0001 7.99967 11.9997 19.0538Z"
      stroke="white"
      stroke-width="1.5"
    />
  </svg>
);

const AddressIcon = () => (

  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.6603 14.4939C17.5224 13.5831 18.0986 12.4397 18.3179 11.2049C18.5371 9.97016 18.3897 8.69822 17.8939 7.54632C17.3981 6.39442 16.5756 5.41305 15.5281 4.72352C14.4807 4.03398 13.2541 3.6665 12 3.6665C10.7459 3.6665 9.51935 4.03398 8.47186 4.72352C7.42438 5.41305 6.60191 6.39442 6.10611 7.54632C5.61031 8.69822 5.46291 9.97016 5.68215 11.2049C5.90138 12.4397 6.47763 13.5831 7.33967 14.4939C7.83436 13.7045 8.52158 13.0538 9.33678 12.603C10.152 12.1521 11.0684 11.9158 12 11.9163C12.9316 11.9158 13.848 12.1521 14.6632 12.603C15.4784 13.0538 16.1656 13.7045 16.6603 14.4939ZM8.68625 15.8442L12 19.157L15.3138 15.8442C15.0166 15.2168 14.5474 14.6866 13.9608 14.3154C13.3742 13.9442 12.6942 13.7471 12 13.7471C11.3058 13.7471 10.6258 13.9442 10.0392 14.3154C9.45259 14.6866 8.98342 15.2168 8.68625 15.8442ZM12 21.7503L6.16634 15.9166C5.01256 14.7628 4.22684 13.2928 3.90852 11.6925C3.5902 10.0921 3.75358 8.43333 4.37801 6.92585C5.00243 5.41836 6.05986 4.12989 7.41656 3.22338C8.77326 2.31686 10.3683 1.83301 12 1.83301C13.6317 1.83301 15.2267 2.31686 16.5834 3.22338C17.9402 4.12989 18.9976 5.41836 19.622 6.92585C20.2464 8.43333 20.4098 10.0921 20.0915 11.6925C19.7732 13.2928 18.9874 14.7628 17.8337 15.9166L12 21.7503ZM12 9.16627C12.2431 9.16627 12.4763 9.06969 12.6482 8.89778C12.8201 8.72588 12.9167 8.49272 12.9167 8.2496C12.9167 8.00649 12.8201 7.77333 12.6482 7.60142C12.4763 7.42951 12.2431 7.33294 12 7.33294C11.7569 7.33294 11.5237 7.42951 11.3518 7.60142C11.1799 7.77333 11.0833 8.00649 11.0833 8.2496C11.0833 8.49272 11.1799 8.72588 11.3518 8.89778C11.5237 9.06969 11.7569 9.16627 12 9.16627ZM12 10.9996C11.2707 10.9996 10.5712 10.7099 10.0555 10.1941C9.53973 9.67842 9.25 8.97895 9.25 8.2496C9.25 7.52026 9.53973 6.82079 10.0555 6.30506C10.5712 5.78933 11.2707 5.4996 12 5.4996C12.7293 5.4996 13.4288 5.78933 13.9445 6.30506C14.4603 6.82079 14.75 7.52026 14.75 8.2496C14.75 8.97895 14.4603 9.67842 13.9445 10.1941C13.4288 10.7099 12.7293 10.9996 12 10.9996Z" fill="white" />
  </svg>

);
const PaymentCardsIcon = () => (
  <svg
    width="84"
    height="24"
    viewBox="0 0 94 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 20V13H11L7.783 16.22C8.33247 16.7819 8.98837 17.2287 9.71241 17.5343C10.4364 17.8399 11.2141 17.9983 12 18C13.2393 17.9982 14.4475 17.6127 15.4589 16.8965C16.4702 16.1802 17.2349 15.1684 17.648 14H17.666C17.78 13.675 17.867 13.34 17.925 13H19.937C19.6934 14.9333 18.7527 16.7111 17.2913 18C15.83 19.2888 13.9485 20 12 20H11.99C10.9398 20.0032 9.89944 19.798 8.9291 19.3963C7.95876 18.9946 7.07772 18.4045 6.337 17.66L4 20ZM6.074 11H4.062C4.30548 9.06751 5.24564 7.29019 6.70616 6.00145C8.16667 4.7127 10.0472 4.00108 11.995 4.00004H12C13.0504 3.99671 14.0909 4.20183 15.0615 4.6035C16.032 5.00517 16.9132 5.59541 17.654 6.34004L20 4.00004V11H13L16.222 7.78004C15.672 7.21752 15.0153 6.77035 14.2903 6.46471C13.5654 6.15907 12.7867 6.0011 12 6.00004C10.7607 6.00187 9.55246 6.38738 8.54114 7.10361C7.52982 7.81985 6.76508 8.83166 6.352 10H6.334C6.219 10.325 6.132 10.66 6.075 11H6.074Z"
      fill="#CCCCCC"
    />
  </svg>
);
const LogoutIcon = () => (
  <svg
    width="84"
    height="24"
    viewBox="0 0 94 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 21H10C9.46957 21 8.96086 20.7893 8.58579 20.4142C8.21071 20.0391 8 19.5304 8 19V15H10V19H19V5H10V9H8V5C8 4.46957 8.21071 3.96086 8.58579 3.58579C8.96086 3.21071 9.46957 3 10 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21ZM12 16V13H3V11H12V8L17 12L12 16Z"
      fill="white"
    />
  </svg>
);